import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import localeData from "dayjs/plugin/localeData";
import {
  IonCard,
  IonCardContent,
  IonCol,
  IonDatetime,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonRow,
} from "@ionic/react";

import { callSharp, logoWhatsapp } from "ionicons/icons";
import CustomDesplegable from "../../components/basicsComponents/CustomDesplegable/CustomDesplegable";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  borrarObjetosDuplicados,
  ordenarArrayObjetosByDate,
} from "../../utils/funcionalidadesArrays";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import CustomCalendar from "../../components/basicsComponents/Calendar";
import { Typography } from "@mui/joy";
import useTituloPagina from "../../hooks/tituloPagina";
import "./NuevoTurno.css";
var weekOfYear = require("dayjs/plugin/weekOfYear");
dayjs.extend(weekOfYear);
dayjs.locale("es");
dayjs.extend(localeData);

export default function NuevoTurno() {
  const diasSemana = [
    "domingo",
    "lunes",
    "martes",
    "miercoles",
    "jueves",
    "viernes",
    "sabado",
  ];
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [especialidades, setEspecialidades] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [listadoPrestadores, setListadoPrestadores] = useState([]);
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(-1);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState(-1);
  const [
    prestadorSeleccionadoExternamente,
    setPrestadorSeleccionadoExternamente,
  ] = useState(false);
  const [fechasFuturas, setFechasFuturas] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState("");
  const [turnosPaciente, setTurnosPaciente] = useState([]);
  const [turnosDisponibles, setTurnosDisponibles] = useState([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [mostrarInasisEspecilidad, setMostrarInasisEspecilidad] =
    useState(false);
  const [mostrarTurnoPrestadorReservado, setMostrarTurnoPrestadorReservado] =
    useState(false);
  const [abrirDesplegableEspecialidades, setAbrirDesplegableEspecialidades] =
    useState(false);
  const [abrirDesplegablePrestadores, setAbrirDesplegablePrestadores] =
    useState(false);

  const [abrirModalConfirmarReserva, setAbrirModalConfirmarReserva] =
    useState(false);
  const [abrirModalPostReserva, setAbrirModalPostReserva] = useState(false);
  const [abrirModalAdvertenciaFondoOjos, setAbrirModalAdvertenciaFondoOjos] =
    useState(false);
  const [prestadorPendiente, setPrestadorPendiente] = useState(-1);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const prestadorActual =
    prestadores.find((p) => p.codigo === prestadorSeleccionado) || null;

  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();

  useTituloPagina();
  const obtenerFotoPrestador = (prestador = {}) => {
    const foto = [
      prestador.foto,
      prestador.Foto,
      prestador.fotoWeb,
      prestador.FotoWeb,
      prestador.imagen,
      prestador.Imagen,
      prestador.imagenWeb,
      prestador.ImagenWeb,
      prestador.fotoBase64,
      prestador.FotoBase64,
      prestador.imagenBase64,
      prestador.ImagenBase64,
    ].find((campo) => typeof campo === "string" && campo.trim() !== "");

    if (typeof foto !== "string" || foto.trim() === "") {
      return "";
    }

    const fotoNormalizada = foto.trim();

    if (
      fotoNormalizada.startsWith("data:") ||
      fotoNormalizada.startsWith("http://") ||
      fotoNormalizada.startsWith("https://")
    ) {
      return fotoNormalizada;
    }

    return `data:image/jpeg;base64,${fotoNormalizada}`;
  };

  const obtenerPrimerosProximosTurnos = async (paciente, prestadores) => {
    let turnos = [];
    let prestadoresFormateados = [];
    let turnosDisponibles = [];
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };
    const url = localStorage.getItem("urlAxioPP");

    try {
      const response = await axios.get(
        `${url}Turnos/TurnosPrestadorFechaXDia/?mutual=${
          paciente.mutual
        }&desde=${dayjs()
          .add(1, "day")
          .format("YYYY/MM/DD HH:mm")}&hasta=${dayjs()
          .add(3, "month")
          .format("YYYY/MM/DD HH:mm")}`,
        config
      );
      if (response.data.length !== 0) turnos = response.data;

      turnosDisponibles = ordenarArrayObjetosByDate(turnos, "fecha");

      prestadores.forEach((prestador) => {
        let proximoTurno = turnosDisponibles.find(
          (turno) => turno.prestador === prestador.codigo
        );
        if (proximoTurno) {
          prestadoresFormateados.push({
            ...prestador,
            note: proximoTurno.fecha,
          });
        }
      });
    } catch (error) {
      throw new Error("Error al obtener los turnos futuros: " + error.message);
    }
    return prestadoresFormateados;
  };

  const traerPrestadores = async (paciente) => {
    let prestadores = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config
      );
      if (response.data.length !== 0) {
        prestadores = response.data;
      }
      prestadores = prestadores.filter(
        (prestador) => prestador.vigente === true
      );

      let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");
      prestadores = prestadores.filter((prestador) => {
        if (prestador.filtroEdad) {
          if (prestador.edadDesde <= edad <= prestador.edadHasta)
            return prestador;
        } else {
          return prestador;
        }
      });

      prestadores = await obtenerPrimerosProximosTurnos(paciente, prestadores);
      console.log(prestadores);

      prestadores = prestadores.map((prestador) => {
        const notaWeb = prestador.notaWeb ? `Nota: ${prestador.notaWeb}` : "";
        console.log(notaWeb);
        return {
          ...prestador,
          text: prestador.nombre,
          imageSrc: obtenerFotoPrestador(prestador),
          fechaProximoTurno: prestador.note,
          note: `Proximo turno: ${obtenerNombreDia(
            dayjs(prestador.note).format("dddd")
          )} ${dayjs(prestador.note).format("DD")} de ${dayjs(
            prestador.note
          ).format("MMMM, YYYY")}`,
          notaWeb,
        };
      });

      prestadores = prestadores.sort((a, b) => {
        if (a.fechaProximoTurno && b.fechaProximoTurno) {
          const fechaA = dayjs(a.fechaProximoTurno);
          const fechaB = dayjs(b.fechaProximoTurno);
          const comparacionFecha = fechaA.diff(fechaB);

          if (comparacionFecha !== 0) {
            return comparacionFecha;
          }
          return a.nombre.localeCompare(b.nombre);
        }

        if (a.fechaProximoTurno && !b.fechaProximoTurno) return -1;
        if (!a.fechaProximoTurno && b.fechaProximoTurno) return 1;

        return a.nombre.localeCompare(b.nombre);
      });

      setPrestadores(prestadores);
      setListadoPrestadores(prestadores);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar los prestadores registrados en el sistema",
        "rojo"
      );
    }
    return prestadores;
  };

  const traerEspecialidades = async (paciente, prestadoresDisponibles) => {
    let especialidades = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Especialidades`, config);
      if (response.data.length !== 0) {
        especialidades = response.data;
      } else {
        especialidades = null;
      }
      especialidades = especialidades.filter(
        (especialidad) => especialidad.vigente === true
      );

      const especialidadesMostrables = [];
      prestadoresDisponibles.forEach((prestador) => {
        const valor = prestador.especialidad;
        if (!especialidadesMostrables.includes(valor)) {
          especialidadesMostrables.push(valor);
        }
      });
      const especialidadesCoincidentes = [];
      especialidades.forEach((especialidad) => {
        if (especialidadesMostrables.includes(especialidad.codigo)) {
          especialidadesCoincidentes.push(especialidad);
        }
      });
      especialidades = especialidadesCoincidentes;
      especialidades = especialidades.map((especialidad) => {
        return {
          ...especialidad,
          text: especialidad.nombre,
        };
      });

      setEspecialidades(especialidades);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar las especialidades registradas en el sistema",
        "rojo"
      );
    }
  };

  const traerTurnosPaciente = async (paciente) => {
    let turnos = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const servicio = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          } else {
            return null;
          }
        });
      if (servicio !== null) {
        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config
        );
        if (response.data.length !== 0) {
          turnos = response.data;
          turnos = turnos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);

            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");

              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnos = turnos.slice(0, 5);
        } else {
          turnos = [];
        }

        setTurnosPaciente(turnos);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus proximos turnos",
        "rojo"
      );
    }
  };

  const CargarDesplegables = async (sesion) => {
    let prestadoresDisponibles = await traerPrestadores(sesion);
    await traerEspecialidades(sesion, prestadoresDisponibles);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerTurnosPaciente(sesion);
        CargarDesplegables(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  {
    useEffect(() => {
      if (
        !abrirDesplegableEspecialidades &&
        especialidadSeleccionada !== -1 &&
        !prestadorSeleccionadoExternamente
      ) {
        setAbrirDesplegablePrestadores(true);
      }
    }, [abrirDesplegableEspecialidades, especialidadSeleccionada]);
  }

  useEffect(() => {
    if (prestadores.length > 0 && especialidades.length > 0) {
      if (
        history.location.state?.prestador !== undefined &&
        history.location.state?.prestador !== null
      ) {
        if (prestadorSeleccionado === -1) {
          setPrestadorSeleccionadoExternamente(true);

          if (
            history.location.state?.accesoDirecto &&
            history.location.state?.especialidadCod
          ) {
            const prestadorEncontrado = prestadores.find(
              (prestador) =>
                prestador.codigo === history.location.state?.prestador
            );

            if (prestadorEncontrado && prestadorEncontrado.vigente) {
              setEspecialidadSeleccionada(
                history.location.state.especialidadCod
              );
              setPrestadorSeleccionado(history.location.state?.prestador);

              const prestadoresFiltrados = prestadores.filter(
                (prestador) =>
                  prestador.especialidad ===
                    history.location.state.especialidadCod ||
                  prestador.especialidad2 ===
                    history.location.state.especialidadCod
              );

              const prestadoresOrdenados = prestadoresFiltrados.sort((a, b) => {
                if (a.fechaProximoTurno && b.fechaProximoTurno) {
                  const fechaA = dayjs(a.fechaProximoTurno);
                  const fechaB = dayjs(b.fechaProximoTurno);
                  const comparacionFecha = fechaA.diff(fechaB);

                  if (comparacionFecha !== 0) {
                    return comparacionFecha;
                  }
                  return a.nombre.localeCompare(b.nombre);
                }

                if (a.fechaProximoTurno && !b.fechaProximoTurno) return -1;
                if (!a.fechaProximoTurno && b.fechaProximoTurno) return 1;

                return a.nombre.localeCompare(b.nombre);
              });

              setListadoPrestadores(prestadoresOrdenados);

              VerificarInasistenciasPorEspecialidad(
                history.location.state.especialidadCod
              );
              VerificarTurnoConPrestadorPendiente(
                history.location.state?.prestador
              );
            } else {
              mostrarNotificacion(
                true,
                prestadorEncontrado
                  ? "El prestador seleccionado no está vigente"
                  : "Prestador no disponible",
                "rojo"
              );
            }
          } else {
            const prestadorEncontrado = prestadores.find(
              (prestador) =>
                prestador.codigo === history.location.state?.prestador
            );

            if (prestadorEncontrado) {
              if (prestadorEncontrado.vigente) {
                setEspecialidadSeleccionada(prestadorEncontrado.especialidad);
                setPrestadorSeleccionado(history.location.state?.prestador);

                const prestadoresFiltrados = prestadores.filter(
                  (prestador) =>
                    prestador.especialidad ===
                      prestadorEncontrado.especialidad ||
                    prestador.especialidad2 === prestadorEncontrado.especialidad
                );

                const prestadoresOrdenados = prestadoresFiltrados.sort(
                  (a, b) => {
                    if (a.fechaProximoTurno && b.fechaProximoTurno) {
                      const fechaA = dayjs(a.fechaProximoTurno);
                      const fechaB = dayjs(b.fechaProximoTurno);
                      const comparacionFecha = fechaA.diff(fechaB);

                      if (comparacionFecha !== 0) {
                        return comparacionFecha;
                      }
                      return a.nombre.localeCompare(b.nombre);
                    }

                    if (a.fechaProximoTurno && !b.fechaProximoTurno) return -1;
                    if (!a.fechaProximoTurno && b.fechaProximoTurno) return 1;

                    return a.nombre.localeCompare(b.nombre);
                  }
                );

                setListadoPrestadores(prestadoresOrdenados);
                VerificarInasistenciasPorEspecialidad(
                  prestadorEncontrado.especialidad
                );
                VerificarTurnoConPrestadorPendiente(
                  history.location.state?.prestador
                );
              } else {
                mostrarNotificacion(
                  true,
                  "El prestador seleccionado no está vigente",
                  "rojo"
                );
              }
            } else {
              mostrarNotificacion(true, "Prestador no disponible", "rojo");
            }
          }

          history.location.state = {};
        } else {
          setPrestadorSeleccionadoExternamente(false);
        }
      } else {
        if (especialidadSeleccionada === -1)
          setAbrirDesplegableEspecialidades(true);
      }
    }
  }, [prestadores, especialidades, history, prestadorSeleccionado]);

  const obtenerTurnos = async (config, prestador) => {
    let turnos = [];
    try {
      const response = await axios.get(
        `${urlAxioPP}Turnos/TurnosPrestadorFecha/?prestador=${prestador}&desde=${dayjs().format(
          "YYYY/MM/DD hh:mm"
        )}&hasta=${dayjs().add(3, "month").format("YYYY/MM/DD hh:mm")}`,
        config
      );
      if (response.data.length !== 0) turnos = response.data;

      const turnosDisponibles = [];
      const turnosDadosMutual = [];

      turnos.forEach((turno) => {
        const diaSemana = dayjs(turno.fecha).get("d");
        const dia = diasSemana[diaSemana];
        let semanaTurno = dayjs(turno.fecha).week();
        let turnosPorSemana = {
          domingo: 0,
          lunes: 0,
          martes: 0,
          miercoles: 0,
          jueves: 0,
          viernes: 0,
          sabado: 0,
        };

        if (
          turno.libre &&
          !turno.cancelado &&
          !turno.entreTurno &&
          !turno.reservado
        ) {
          turnosDisponibles.push(turno);
        }

        let turnosSemana = turnosDadosMutual.find(
          (turno) => turno.semana === semanaTurno
        );
        if (!turnosSemana) {
          turnosPorSemana[dia] += 1;
          turnosDadosMutual.push({
            semana: semanaTurno,
            ...turnosPorSemana,
            totalTurnosAsignadosMutual: 1,
          });
        } else {
          if (turno.mutual === usuario.mutual) {
            turnosSemana = {
              ...turnosSemana,
              [dia]: turnosSemana[dia] + 1,
              totalTurnosAsignadosMutual:
                turnosSemana.totalTurnosAsignadosMutual + 1,
            };
            turnosDadosMutual[
              turnosDadosMutual.findIndex(
                (turno) => turno.semana === semanaTurno
              )
            ] = turnosSemana;
          }
        }
      });

      return { turnosDadosMutual, turnosDisponibles };
    } catch (error) {
      throw new Error(
        "Error al obtener los turnos disponibles: " + error.message
      );
    }
  };

  const filtrarTurnosPorFechaYHora = (turnos) => {
    return turnos.filter(
      (turno) =>
        dayjs(turno.fecha).isSame(dayjs()) ||
        (dayjs(turno.fecha).isAfter(dayjs()) &&
          (dayjs().format("YYYY-MM-DD") !==
            dayjs(turno.fecha).format("YYYY-MM-DD") ||
            (dayjs().format("YYYY-MM-DD") ===
              dayjs(turno.fecha).format("YYYY-MM-DD") &&
              dayjs(turno.hora).format("HH:mm") >
                dayjs().add(3, "hour").format("HH:mm"))))
    );
  };

  const filtrarTurnosPorRestricciones = (
    turnos,
    atiende,
    turnosDadosMutual
  ) => {
    return turnos.filter((turno) => {
      if (atiende.length === 0) {
        return true;
      } else {
        const diaSemana = dayjs(turno.fecha).get("d");
        const cantidadTurnosDia =
          atiende[0][diasSemana[diaSemana].toLowerCase()];
        const turnosOcupadosDia = turnosDadosMutual.find(
          (turnoMutual) => turnoMutual.semana === dayjs(turno.fecha).week()
        )[diasSemana[diaSemana].toLowerCase()];
        return turnosOcupadosDia < cantidadTurnosDia;
      }
    });
  };

  const obtenerFechasTurnos = (turnosFiltrados) => {
    const fechasTurnos = borrarObjetosDuplicados(turnosFiltrados, "fecha", true)
      .filter((turno) => turno)
      .map((turno) => ({
        fecha: turno,
      }));
    return fechasTurnos;
  };

  const obtenerProximosTurnos = (
    fechasTurnos,
    horarios,
    turnosFiltradosPorRestricciones
  ) => {
    const turnosProximos = [];
    fechasTurnos.forEach((fecha) => {
      const diaSemana = dayjs(fecha.fecha).get("d");
      const fechaTurno = dayjs(fecha.fecha).format("YYYY-MM-DD");
      const cantTurnos = turnosFiltradosPorRestricciones.filter((turno) =>
        dayjs(turno.fecha).isSame(dayjs(fecha.fecha))
      ).length;
      if (
        (horarios[diasSemana[diaSemana].toLowerCase() + "MDe"] !== "" &&
          horarios[diasSemana[diaSemana].toLowerCase() + "MHa"]) ||
        (horarios[diasSemana[diaSemana].toLowerCase() + "TDe"] !== "" &&
          horarios[diasSemana[diaSemana].toLowerCase() + "THa"] !== "")
      ) {
        turnosProximos.push({
          date: fechaTurno,
          cantTurnos: cantTurnos,
          textColor: "#e6e5f1",
          backgroundColor: "#695194",
        });
      }
    });
    return turnosProximos;
  };

  const traerTurnosAgenda = async (config, prestador, horarios, atiende) => {
    try {
      const { turnosDadosMutual, turnosDisponibles } = await obtenerTurnos(
        config,
        prestador
      );

      const turnosFiltradosPorFechaYHora =
        filtrarTurnosPorFechaYHora(turnosDisponibles);

      const turnosFiltradosPorRestricciones = filtrarTurnosPorRestricciones(
        turnosFiltradosPorFechaYHora,
        atiende,
        turnosDadosMutual
      );

      const fechasTurnos = obtenerFechasTurnos(turnosFiltradosPorRestricciones);

      const turnosProximos = obtenerProximosTurnos(
        fechasTurnos,
        horarios,
        turnosFiltradosPorRestricciones
      );
      if (turnosProximos.length !== 0) {
        setFechasFuturas(ordenarArrayObjetosByDate(turnosProximos, "date"));
        setFechaSeleccionada(
          ordenarArrayObjetosByDate(turnosProximos, "date")[0].date
        );
        setTurnosDisponibles(
          ordenarArrayObjetosByDate(turnosFiltradosPorRestricciones, "hora")
        );
      } else {
        mostrarNotificacion(
          true,
          "No hay turnos disponibles con el prestador seleccionado",
          "amarillo"
        );
      }
    } catch (error) {
      mostrarNotificacion(true, "Error: " + error.message, "rojo");
    }
  };

  const traerHorariosAtencion = async (prestador) => {
    let horarios = null;
    let atiende = [];

    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };

    const servicio = await axios
      .get(`${urlAxioPP}Servicios`, config)
      .then((response) => {
        if (response.data.length !== 0) {
          return response.data[0];
        } else {
          return null;
        }
      });

    try {
      const [horariosResponse, atiendeResponse] = await Promise.all([
        axios.get(`${urlAxioPP}PrestadoresHorarios/${prestador}`, config),
        axios.get(
          `${urlAxioPP}Prestadores/RestriccionesPorMutual/${prestador}`,
          config
        ),
      ]);

      if (
        horariosResponse.data.filter(
          (horario) => horario.prestador === prestador
        ).length > 0
      ) {
        horarios = horariosResponse.data.filter(
          (horario) => horario.prestador === prestador
        );
      }
      atiende = atiendeResponse.data.filter((a) => a.mutual === usuario.mutual);

      if (!horarios || !horarios[0]?.prestador) {
        mostrarNotificacion(
          true,
          "El prestador seleccionado no tiene un horario definido",
          "rojo"
        );
      } else {
        await traerTurnosAgenda(config, prestador, horarios[0], atiende);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al intentar consultar los horarios disponibles del prestador",
        "rojo"
      );
    }
  };

  const actualizarTurno = async () => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${usuario.token}` },
      };

      if (turnoSeleccionado) {
        const actualizarTurnoResponse = await axios.patch(
          `${urlAxioPP}Turnos/DarTurno/${turnoSeleccionado.codigo}`,
          {
            codigo: turnoSeleccionado.codigo,
            paciente: usuario.codigo,
            mutual: usuario.mutual,
            // estudio: 0,
            prestador: prestadorSeleccionado,
            telemedicina: turnoSeleccionado.telemedicina,
            observaciones: "Turno reservado via web por el paciente",
          },
          config
        );
        if (actualizarTurnoResponse.status === 200) {
          mostrarNotificacion(
            true,
            "El turno se reservó correctamente",
            "verde"
          );

          togleAbrirCerrarConfirmarReserva(true);
          setFechaSeleccionada("");
          setTurnosDisponibles([]);
          // await traerTurnosPaciente(usuario);
          setAbrirModalPostReserva(true);
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar reservar el turno",
            "rojo"
          );
        }
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const VerificarInasistenciasPorEspecialidad = (especialidad) => {
    const turnosPasados = turnosPaciente;
    let inasistidos = 0;

    turnosPasados.forEach((turno) => {
      if (
        (dayjs(turno.fecha).isSame(new dayjs()) &&
          dayjs(turno.hora).format("HH:mm") >=
            dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
        (dayjs(turno.fecha).isAfter(new dayjs().subtract(2, "month")) &&
          dayjs(turno.fecha).isBefore(new dayjs()))
      ) {
        if (turno.especialidad === especialidad && turno.asistio === false) {
          inasistidos += 1;
        }
      }
    });

    setMostrarTurnoPrestadorReservado(false);
    if (inasistidos > 1) {
      setFechasFuturas([]);
      setMostrarInasisEspecilidad(true);
    } else {
      setMostrarInasisEspecilidad(false);
    }
  };

  const VerificarTurnoConPrestadorPendiente = (prestador) => {
    const turnosFuturos = turnosPaciente;
    let turnoPendiente = false;
    turnosFuturos.forEach((turno) => {
      if (
        (dayjs(turno.fecha).isSame(new dayjs()) &&
          dayjs(turno.hora).format("HH:mm") <=
            dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
        (dayjs(turno.fecha).isBefore(new dayjs().add(2, "month")) &&
          dayjs(turno.fecha).isAfter(new dayjs()))
      ) {
        if (turno.prestadorCod === prestador) {
          turnoPendiente = true;
        }
      }
    });

    if (turnoPendiente) {
      setFechasFuturas([]);
      setMostrarTurnoPrestadorReservado(true);
    } else {
      setMostrarTurnoPrestadorReservado(false);
      traerHorariosAtencion(prestador);
    }
  };

  const seleccionarProfesional = (value) => {
    let encontrado = false;

    if (especialidadSeleccionada === -1) {
      let prestadorSeleccionadoTemp = prestadores.filter(
        (prestador) => prestador.codigo === value
      );
      if (prestadorSeleccionadoTemp.length !== 0) {
        handleChangeSelect(
          prestadorSeleccionadoTemp[0].especialidad,
          "Especialidad"
        );
        encontrado = true;
        setPrestadorSeleccionado(value);
        VerificarTurnoConPrestadorPendiente(value);
      }
    } else {
      setPrestadorSeleccionado(value);
      VerificarTurnoConPrestadorPendiente(value);
    }

    return encontrado;
  };

  const handleContinuarConPrestador = () => {
    if (prestadorPendiente !== -1) {
      seleccionarProfesional(prestadorPendiente);
    }
    setPrestadorPendiente(-1);
  };

  const handleCancelarSeleccionPrestador = () => {
    setPrestadorPendiente(-1);
  };

  const handleChangeSelect = (value, select) => {
    let encontrado = false;
    setCargando(true);
    switch (select) {
      case "Especialidad":
        setEspecialidadSeleccionada(value);
        if (value !== -1) {
          let prestadoresFiltrados = prestadores.filter(
            (prestador) =>
              prestador.especialidad === value ||
              prestador.especialidad2 === value
          );

          prestadoresFiltrados = prestadoresFiltrados.sort((a, b) => {
            if (a.fechaProximoTurno && b.fechaProximoTurno) {
              const fechaA = dayjs(a.fechaProximoTurno);
              const fechaB = dayjs(b.fechaProximoTurno);
              const comparacionFecha = fechaA.diff(fechaB);

              if (comparacionFecha !== 0) {
                return comparacionFecha;
              }
              return a.nombre.localeCompare(b.nombre);
            }

            if (a.fechaProximoTurno && !b.fechaProximoTurno) return -1;
            if (!a.fechaProximoTurno && b.fechaProximoTurno) return 1;

            return a.nombre.localeCompare(b.nombre);
          });

          setListadoPrestadores(prestadoresFiltrados);
        } else {
          setListadoPrestadores(prestadores);
        }
        setPrestadorSeleccionado(-1);
        setFechasFuturas([]);
        VerificarInasistenciasPorEspecialidad(value);
        break;
      case "Profesional":
        setPrestadorPendiente(value);
        setAbrirModalAdvertenciaFondoOjos(true);
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
    setCargando(false);
    return encontrado;
  };

  const handleChangeFecha = (value) => {
    setFechaSeleccionada(value);
  };

  const togleAbrirCerrarConfirmarReserva = (confirma = false) => {
    if (abrirModalConfirmarReserva && !confirma) {
      setTurnoSeleccionado({});
      // handleChangeSelect(-1, "Especialidad");
    }
    setAbrirModalConfirmarReserva(!abrirModalConfirmarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    setTurnoSeleccionado(turno);
    togleAbrirCerrarConfirmarReserva();
  };

  const handleClickConfirmarHacerReserva = async () => {
    setCargando(true);
    await actualizarTurno();
    setCargando(false);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "08105552765";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el numero de telefono a su portapapeles",
      ""
    );
  };

  const handlePostTurnoReservado = (accion) => {
    setTurnoSeleccionado({});
    setAbrirModalPostReserva(false);
    switch (accion) {
      case "nuevoTurno":
        window.location.reload();
        break;
      case "turnosPaciente":
        history.push({ pathname: "/portal/Turnos" });
        break;
      default:
        history.push({ pathname: "/portal/Turnos" });
        break;
    }
  };

  const renderTurnos = () => {
    let turnos = turnosDisponibles.filter(
      (turno) =>
        dayjs(turno.fecha).format("YYYY-MM-DD") ===
        dayjs(fechaSeleccionada).format("YYYY-MM-DD")
    );

    return turnos.map((turno) => (
      <Column container xs={6} md={3} key={turno.codigo}>
        <StyledButton
          expand="block"
          className="blanco"
          onClick={() => handleClickSeleccionarTurno(turno)}
        >
          {dayjs(turno.hora).format("HH:mm")}
        </StyledButton>
      </Column>
    ));
  };

  return (
    <>
      <div slot="content">
        <Container>
          <Row container width="100%">
            <Column xs={12} md={6}>
              <IonItem className="amarillo-sol">
                <CustomDesplegable
                  array={especialidades}
                  value={especialidadSeleccionada}
                  handleChange={handleChangeSelect}
                  mostrarTodos={false}
                  mostrarSearch={true}
                  placeholder="Seleccione una especialidad..."
                  label="Especialidades"
                  id="Especialidad"
                  isOpen={abrirDesplegableEspecialidades}
                  setIsOpen={setAbrirDesplegableEspecialidades}
                  variant="plain"
                />
              </IonItem>
            </Column>
            {especialidadSeleccionada !== -1 && (
              <Column xs={12} md={6}>
                <IonItem className="amarillo-sol">
                  <CustomDesplegable
                    array={listadoPrestadores}
                    value={prestadorSeleccionado}
                    handleChange={handleChangeSelect}
                    mostrarTodos={false}
                    mostrarSearch={true}
                    placeholder="Seleccione un profesional..."
                    label="Profesionales"
                    id="Profesional"
                    isOpen={abrirDesplegablePrestadores}
                    setIsOpen={setAbrirDesplegablePrestadores}
                    variant="plain"
                  />
                </IonItem>
              </Column>
            )}
          </Row>
        </Container>
        {/*NotaWeb*/}
        {prestadorActual?.imageSrc && (
          <Container className="reserva-prestador-foto-wrapper">
            <Row container width="100%">
              <Column xs={12} md={6}>
                <div className="reserva-prestador-foto-card">
                  <div className="reserva-prestador-foto-frame">
                    <img
                      src={prestadorActual.imageSrc}
                      alt={prestadorActual.nombre}
                      className="reserva-prestador-foto"
                    />
                  </div>
                  <div className="reserva-prestador-foto-info">
                    <Typography
                      level="title-sm"
                      className="reserva-prestador-foto-nombre"
                    >
                      {prestadorActual.nombre}
                    </Typography>
                  </div>
                </div>
              </Column>
            </Row>
          </Container>
        )}

        {prestadorActual && prestadorActual.notaWeb ? (
          <IonCard
            color="warning"
            style={{
              textAlign: "start",
              borderRadius: "5px",
              fontSize: "2rem",
            }}
          >
            <IonCardContent>{prestadorActual.notaWeb}</IonCardContent>
          </IonCard>
        ) : null}

        {fechasFuturas.length > 0 && (
          <IonGrid>
            <IonRow>
              <IonCol>
                <CustomCalendar
                  onChange={(newSelectedDate) =>
                    handleChangeFecha(
                      dayjs(newSelectedDate).format("YYYY-MM-DD")
                    )
                  }
                  minDate={dayjs(new dayjs())}
                  maxDate={dayjs(new dayjs()).add(3, "months")}
                  value={fechaSeleccionada}
                  highlightedDates={fechasFuturas}
                />
              </IonCol>
              {turnosDisponibles.length > 0 && (
                <IonCol>
                  <IonList lines="none">
                    <IonListHeader>
                      <Typography level="body-md">
                        {`${obtenerNombreDia(
                          dayjs(fechaSeleccionada).format("dddd")
                        )} ${dayjs(fechaSeleccionada).format("DD")} de ${dayjs(
                          fechaSeleccionada
                        ).format("MMMM, YYYY")} - Horarios disponibles`}
                      </Typography>
                    </IonListHeader>

                    <IonGrid>
                      <IonRow>{renderTurnos()}</IonRow>
                    </IonGrid>
                  </IonList>
                </IonCol>
              )}
            </IonRow>
          </IonGrid>
        )}
      </div>

      {mostrarInasisEspecilidad && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No podes reservar un nuevo turno con esta especialidad
                  debido a que no asististe a 2 o mas turnos en los ultimos 2
                  meses para la especialidad que seleccionaste. Estaremos
                  encantados de atenderte y brindarte la mejor atención
                  personalizada si te pones en contacto. Podes presionar los
                  botones inferiores para copiar el numero de telefono fijo o
                  llevarte a nuestro chat de Whatsapp.
                </h4>
              </IonCardContent>
              <IonRow>
                <IonCol>
                  <StyledButton
                    className="verde"
                    expand="block"
                    // href="https://api.whatsapp.com/send?phone=5493513455853&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20poder%20sacar%20un%20turno%20para%20tratamientos%20estéticos"
                  >
                    <IonIcon icon={logoWhatsapp} />
                    <IonLabel>WhatsApp</IonLabel>
                  </StyledButton>
                </IonCol>
                <IonCol>
                  <StyledButton
                    className="blanco"
                    expand="block"
                    onClick={handleClickCopiarTelefono}
                  >
                    <IonIcon icon={callSharp} />
                    <IonLabel>Telefono</IonLabel>
                  </StyledButton>
                </IonCol>
              </IonRow>
            </IonCard>
          </IonCol>
        </IonRow>
      )}
      {mostrarTurnoPrestadorReservado && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No esta permitido sacar un segundo turno para un mismo
                  prestador
                </h4>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      )}

      <DialogoConfirmacion
        titulo="Fondo de ojos"
        texto="Si necesita realizarse este estudio, solicite su turno a través de nuestras líneas de WhatsApp. No se agenda en los últimos turnos de los médicos."
        open={abrirModalAdvertenciaFondoOjos}
        setOpen={setAbrirModalAdvertenciaFondoOjos}
        handleClickConfirmar={handleContinuarConPrestador}
        handleClickCancelar={handleCancelarSeleccionPrestador}
        colorBotonNo="neutral"
        colorBotonSi="warning"
        variantDialog="plain"
        colorDialogo="warning"
        textoBotonNo="Volver"
        textoBotonSi="Continuar"
      />

      <DialogoConfirmacion
        titulo="Reservar turno"
        texto={`Ha seleccionado el turno con el/la profesional ${
          turnoSeleccionado.prestadorNom
        }, con especialidad en ${
          turnoSeleccionado.especialidadNom
        }, para el día ${dayjs(turnoSeleccionado.fecha).format(
          "DD/MM/YYYY"
        )}, a las ${dayjs(turnoSeleccionado.hora).format(
          "HH:mm"
        )}, ¿es esto correcto?`}
        open={abrirModalConfirmarReserva}
        setOpen={setAbrirModalConfirmarReserva}
        handleClickConfirmar={handleClickConfirmarHacerReserva}
        colorBotonNo="danger"
        colorBotonSi="success"
        textoBotonNo="No, Revisar"
        textoBotonSi="Si, Confirmar"
      />

      <DialogoConfirmacion
        titulo="Turno reservado"
        texto={`Se ha reservado exitosamente el turno con el/la profesional ${
          turnoSeleccionado.prestadorNom
        }, con especialidad en ${
          turnoSeleccionado.especialidadNom
        }, para el día ${dayjs(turnoSeleccionado.fecha).format(
          "DD/MM/YYYY"
        )}, a las ${dayjs(turnoSeleccionado.hora).format("HH:mm")}`}
        open={abrirModalPostReserva}
        setOpen={setAbrirModalPostReserva}
        handleClickConfirmar={() => handlePostTurnoReservado("nuevoTurno")}
        handleClickCancelar={() => handlePostTurnoReservado("turnosPaciente")}
        variantBotonNo="solid"
        colorBotonNo="primary"
        variantBotonSi="solid"
        colorBotonSi="primary"
        variantDialog="plain"
        colorDialogo="success"
        textoBotonNo="Consultar mis turnos"
        textoBotonSi="Reservar nuevo turno"
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
